import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonLabel, IonRow,
  IonSpinner,
  IonText,
  IonToolbar
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import React from 'react';
import { WithdrawStore } from 'stores/WithdrawStore';
import currencyFormat from 'utils/Currency';
import './WithdrawPreviewModal.css';

const styles = {
  rowStyles: {
    marginTop: 40
  },
  textAlignCenter: {
    textAlign: 'center'
  }
};

const WithdrawPreviewModal: React.FC<{
  isOpen: boolean;
  state: any;
  isBTC: boolean;
  sats_amount: number | undefined;
  fiat_value: number | undefined;
  withdrawType: 'ln' | 'chain';
  onSubmit: () => void;
  onDismiss: () => void;
}> = ({
  state,
  fiat_value,
  sats_amount,
  onDismiss,
  withdrawType,
  isBTC,
  onSubmit
}) => {
  const loading = WithdrawStore.useState((s:any) => s.loading);

  const submit = async () => {
    WithdrawStore.update((s:any) => {
      s.loading = true;
    })
    onSubmit();
  };

  return (
    <div className={'withdraw-preview-modal'}>
      <IonHeader className={'ion-no-border'}>
        <IonToolbar className={'background-color'}>
          <IonButton
            slot="end"
            color={'dark'}
            disabled={loading}
            fill={'clear'}
            onClick={() => onDismiss()}>
            <IonIcon icon={closeOutline} />
          </IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent scrollY={false} scrollEvents={false} scrollX={false}>
        <IonGrid>
          <IonRow style={styles.rowStyles}>
            <IonCol>
              <IonText style={styles.textAlignCenter}>
                <p>Withdrawing</p>
              </IonText>
              {withdrawType === 'ln' ? (
                <IonText style={styles.textAlignCenter}>
                  <h1>{currencyFormat(sats_amount)} sats</h1>
                  {fiat_value && (
                    <p>${currencyFormat(fiat_value.toFixed(2))}</p>
                  )}
                </IonText>
              ) : (
                <IonText style={styles.textAlignCenter}>
                  <h1>
                    {isBTC
                      ? `${currencyFormat(sats_amount)} sats`
                      : `$${currencyFormat(sats_amount)}`}
                  </h1>
                </IonText>
              )}
            </IonCol>
          </IonRow>
          <IonRow style={styles.rowStyles}>
            <IonCol>
              <IonLabel position={'stacked'}>
                {withdrawType === 'ln'
                  ? "Lightning Invoice"
                  : "Money Address"}
              </IonLabel>
              <IonInput
                disabled
                name={'ln_invoice'}
                value={
                  withdrawType === 'ln'
                    ? state?.ln_invoice
                    : state.wallet_address
                }
              />
            </IonCol>
          </IonRow>
          <IonRow style={styles.rowStyles}>
            <IonCol>
              <IonButton
                className={'confirm-withdraw'}
                disabled={loading}
                expand={'block'}
                onClick={submit}>
                {loading ? (
                  <IonSpinner name={'circular'} />
                ) : (
                  "Confirm Withdraw"
                )}
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </div>
  );
};

export default WithdrawPreviewModal;
